import axios, { AxiosError, CancelToken } from 'axios'
import { getRequestConfig } from 'client/api/index'
import {
  iCountResponse,
  iGetResponse,
  iParamObject,
  iUpdateNotificationObject,
} from 'client/Interfaces/notifications/NotificationsInterface'

export async function getNotifications(paramObj: iParamObject, cancel: CancelToken): Promise<iGetResponse> {
  const requestConfig: {
    headers: object
    params: iParamObject
    cancelToken: CancelToken
  } = {
    ...getRequestConfig(),
    params: paramObj,
    cancelToken: cancel,
  }

  const response = await axios
    .get('/notifications-api/v1/notifications', requestConfig)
    .catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        console.error(err.response?.data)
        console.error(err.response?.status)
        console.error(err.response?.headers)
      } else {
        console.error('Error', err.message)
      }
      return null
    })

  return response?.data as iGetResponse
}

export async function getNotificationCount(): Promise<iCountResponse> {
  const response = await axios
    .get('/notifications-api/v1/notifications/count', getRequestConfig())
    .catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        console.error(err.response?.data)
        console.error(err.response?.status)
        console.error(err.response?.headers)
      } else {
        console.error('Error', err.message)
      }
      return null
    })
  return response?.data
}

export async function updateIsDeleted(data: iUpdateNotificationObject, isDeleted: boolean): Promise<void> {
  const response = await axios
    .patch(
      `/notifications-api/v1/notifications/${data.notifications[0].notificationId}/` +
        `update-delete-flag?isDeleted=${String(isDeleted)}`,
      data,
      getRequestConfig(),
    )
    .catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        console.error(err.response?.data)
        console.error(err.response?.status)
        console.error(err.response?.headers)
      } else {
        console.error('Error', err.message)
      }
      return null
    })

  return response?.data
}

export async function updateAllIsDeleted(isDeleted: boolean): Promise<void> {
  const response = await axios
    .patch(`/notifications-api/v1/notifications/update-all?deleteAll=${String(isDeleted)}`, '', getRequestConfig())
    .catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        console.error(err.response?.data)
        console.error(err.response?.status)
        console.error(err.response?.headers)
      } else {
        console.error('Error', err.message)
      }
      return null
    })

  return response?.data
}

export async function updateIsRead(data: iUpdateNotificationObject): Promise<void> {
  const response = await axios
    .patch('/notifications-api/v1/notifications/update-read-flag', data, getRequestConfig())
    .catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        console.error(err.response?.data)
        console.error(err.response?.status)
        console.error(err.response?.headers)
      } else {
        console.error('Error', err.message)
      }
      return null
    })

  return response?.data
}

export async function updateAllIsRead(): Promise<void> {
  const response = await axios
    .patch('/notifications-api/v1/notifications/update-all?readAll=true', '', getRequestConfig())
    .catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        console.error(err.response?.data)
        console.error(err.response?.status)
        console.error(err.response?.headers)
      } else {
        console.error('Error', err.message)
      }
      return null
    })

  return response?.data
}
